"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.string.bold.js");
require("core-js/modules/es6.function.name.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _gridStyled = require("grid-styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _product = require("@nucleo/product");
var _lodash = require("lodash");
var _jsxFileName = "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/MatchTeamDetail.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_ixxzv2rg4() {
  var path = "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/MatchTeamDetail.js";
  var hash = "002d7f3b40167536bc85570753361401a4dd5a55";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src828252154/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/Product/lib/MatchTeamDetail.js",
    statementMap: {
      "0": {
        start: {
          line: 25,
          column: 17
        },
        end: {
          line: 45,
          column: 1
        }
      },
      "1": {
        start: {
          line: 47,
          column: 13
        },
        end: {
          line: 67,
          column: 1
        }
      },
      "2": {
        start: {
          line: 69,
          column: 16
        },
        end: {
          line: 98,
          column: 1
        }
      },
      "3": {
        start: {
          line: 100,
          column: 21
        },
        end: {
          line: 117,
          column: 1
        }
      },
      "4": {
        start: {
          line: 119,
          column: 17
        },
        end: {
          line: 139,
          column: 1
        }
      },
      "5": {
        start: {
          line: 141,
          column: 31
        },
        end: {
          line: 167,
          column: 1
        }
      },
      "6": {
        start: {
          line: 169,
          column: 21
        },
        end: {
          line: 199,
          column: 1
        }
      },
      "7": {
        start: {
          line: 201,
          column: 17
        },
        end: {
          line: 205,
          column: 1
        }
      },
      "8": {
        start: {
          line: 202,
          column: 2
        },
        end: {
          line: 204,
          column: 9
        }
      },
      "9": {
        start: {
          line: 207,
          column: 0
        },
        end: {
          line: 211,
          column: 2
        }
      },
      "10": {
        start: {
          line: 213,
          column: 0
        },
        end: {
          line: 215,
          column: 2
        }
      },
      "11": {
        start: {
          line: 218,
          column: 17
        },
        end: {
          line: 218,
          column: 87
        }
      },
      "12": {
        start: {
          line: 219,
          column: 2
        },
        end: {
          line: 231,
          column: 4
        }
      },
      "13": {
        start: {
          line: 234,
          column: 0
        },
        end: {
          line: 243,
          column: 2
        }
      },
      "14": {
        start: {
          line: 245,
          column: 0
        },
        end: {
          line: 248,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 201,
            column: 17
          },
          end: {
            line: 201,
            column: 18
          }
        },
        loc: {
          start: {
            line: 202,
            column: 2
          },
          end: {
            line: 204,
            column: 9
          }
        },
        line: 202
      },
      "1": {
        name: "MatchTeamDetail",
        decl: {
          start: {
            line: 217,
            column: 9
          },
          end: {
            line: 217,
            column: 24
          }
        },
        loc: {
          start: {
            line: 217,
            column: 59
          },
          end: {
            line: 232,
            column: 1
          }
        },
        line: 217
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 218,
            column: 17
          },
          end: {
            line: 218,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 218,
            column: 18
          },
          end: {
            line: 218,
            column: 22
          }
        }, {
          start: {
            line: 218,
            column: 26
          },
          end: {
            line: 218,
            column: 78
          }
        }, {
          start: {
            line: 218,
            column: 83
          },
          end: {
            line: 218,
            column: 87
          }
        }],
        line: 218
      },
      "1": {
        loc: {
          start: {
            line: 223,
            column: 9
          },
          end: {
            line: 223,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 223,
            column: 9
          },
          end: {
            line: 223,
            column: 22
          }
        }, {
          start: {
            line: 223,
            column: 26
          },
          end: {
            line: 223,
            column: 64
          }
        }],
        line: 223
      },
      "2": {
        loc: {
          start: {
            line: 227,
            column: 9
          },
          end: {
            line: 227,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 227,
            column: 9
          },
          end: {
            line: 227,
            column: 26
          }
        }, {
          start: {
            line: 227,
            column: 30
          },
          end: {
            line: 227,
            column: 72
          }
        }],
        line: 227
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "002d7f3b40167536bc85570753361401a4dd5a55"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ixxzv2rg4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ixxzv2rg4();
var TeamLogo = (cov_ixxzv2rg4().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.img.attrs({
  className: 'g-TeamImage',
  alt: ''
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      padding: 0 ", ";\n      vertical-align: middle;\n      height: 35px;\n      margin-top: auto;\n      margin-bottom: auto;\n    "])), _stylingConstants.default.spacing.small)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      width: 48px;\n      object-fit: contain;\n      height: 48px;\n      border-radius: var(--generalBorderRadiusSmall);\n    "]))))));
var Name = (cov_ixxzv2rg4().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.p.attrs({
  className: 'g-TeamName semantic-no-styling'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      display: inline-block;\n      vertical-align: middle;\n      font-size: ", ";\n      font-weight: bolder;\n    "])), _stylingConstants.default.font.sizeMS)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      display: inline-block;\n      vertical-align: middle;\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      color: var(--textColor);\n    "])), (0, _lodash.get)(_themeMapper.evolutionTheme, 'typography.body2.fontSize', '16px'), (0, _lodash.get)(_themeMapper.evolutionTheme, 'typography.body2.lineHeight', '24px'), (0, _lodash.get)(_themeMapper.evolutionTheme, 'fontWeight.bold', 700)))));
var TeamBox = (cov_ixxzv2rg4().s[2]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: 'g-TeamBox'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      display: inline-flex;\n      margin-top: auto;\n      margin-bottom: auto;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n      display: inline-flex;\n      overflow: hidden;\n      flex-wrap: wrap;\n      gap: ", "px;\n      justify-content: center;\n      align-items: center;\n\n      > .g-MatchTeamNameWrapper {\n        flex: 1;\n        margin-top: ", "px;\n        align-items: start;\n        justify-content: flex-end;\n        @media (max-width: 390px) {\n          width: 100%\n        }\n      }\n    "])), (0, _lodash.get)(_themeMapper.evolutionTheme, 'spacings.md', 8), (0, _lodash.get)(_themeMapper.evolutionTheme, 'spacings.md', 8)))));
var TeamOpposing = (cov_ixxzv2rg4().s[3]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(TeamBox).attrs({
  className: 'g-TeamBox-Opposing'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n      text-align: left;\n      align-items: flex-start;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n      text-align: left;\n      justify-content: flex-start;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 8px;\n    "]))))));
var TeamHost = (cov_ixxzv2rg4().s[4]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(TeamBox).attrs({
  className: 'g-TeamBox-Host'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n      text-align: right;\n      justify-content: flex-end;\n      align-items: flex-end;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n      justify-content: flex-end;\n      flex-direction: column;\n      flex-wrap: wrap-reverse;\n      text-align: right;\n      gap: 8px;\n      flex-direction: column-reverse;\n      align-items: end;\n    "]))))));
var MatchTeamDetailWrapper = (cov_ixxzv2rg4().s[5]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: 'g-MatchTeamDetailWrapper'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n      display: inline-flex;\n      width: 100%;\n      > div {\n        align-items: center;\n      }\n      > text {\n        font-weight: bolder;\n      }\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n      display: inline-flex;\n      width: 100%;\n      justify-content: space-between;\n      gap: 12px;\n\n      > text {\n        font-weight: bolder;\n      }\n    "]))))));
var MatchVsLabel = (cov_ixxzv2rg4().s[6]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'g-MatchVsLabel'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n      font-size: 0.8em;\n      vertical-align: baseline;\n      padding: 0 8px;\n      text-align: center;\n      line-height: 25px;\n      height: 25px;\n      margin-top: auto;\n      margin-bottom: auto;\n      @media screen and (max-width: 40em) {\n        padding: 0;\n      }\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n      vertical-align: baseline;\n      text-align: center;\n      margin-top: auto;\n      margin-bottom: auto;\n      padding: 0;\n      color: var(--subtleTextColor);\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n    "])), _themeMapper.evolutionTheme.typography.body2.fontSize, _themeMapper.evolutionTheme.typography.body2.lineHeight, _themeMapper.evolutionTheme.fontWeight.bold))));
cov_ixxzv2rg4().s[7]++;
var TeamName = function TeamName(_ref) {
  var name = _ref.name;
  cov_ixxzv2rg4().f[0]++;
  cov_ixxzv2rg4().s[8]++;
  return /*#__PURE__*/_react.default.createElement(_gridStyled.Flex, {
    className: "g-MatchTeamNameWrapper",
    align: ['center'],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 202,
      columnNumber: 3
    }
  }, /*#__PURE__*/_react.default.createElement(Name, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 203,
      columnNumber: 5
    }
  }, name));
};
cov_ixxzv2rg4().s[9]++;
TeamName.propTypes = {
  /* The product object to display */
  name: _propTypes.default.string.isRequired,
  themeContext: _themeProvider.ThemeContextType
};
cov_ixxzv2rg4().s[10]++;
TeamName.defaultProps = {
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT
};
function MatchTeamDetail(_ref2) {
  var hostTeam = _ref2.hostTeam,
    opposingTeam = _ref2.opposingTeam,
    intl = _ref2.intl;
  cov_ixxzv2rg4().f[1]++;
  var versus = (cov_ixxzv2rg4().s[11]++, (cov_ixxzv2rg4().b[0][0]++, intl) && (cov_ixxzv2rg4().b[0][1]++, intl.formatMessage({
    id: 'gravity.Product.versus'
  })) || (cov_ixxzv2rg4().b[0][2]++, 'vs'));
  cov_ixxzv2rg4().s[12]++;
  return /*#__PURE__*/_react.default.createElement(MatchTeamDetailWrapper, {
    my: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 220,
      columnNumber: 5
    }
  }, /*#__PURE__*/_react.default.createElement(TeamHost, {
    width: [1],
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 221,
      columnNumber: 7
    }
  }, /*#__PURE__*/_react.default.createElement(TeamName, {
    name: hostTeam.name,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 222,
      columnNumber: 9
    }
  }), (cov_ixxzv2rg4().b[1][0]++, hostTeam.logo) && (cov_ixxzv2rg4().b[1][1]++, /*#__PURE__*/_react.default.createElement(TeamLogo, {
    src: hostTeam.logo.small,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 223,
      columnNumber: 27
    }
  }))), /*#__PURE__*/_react.default.createElement(MatchVsLabel, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 225,
      columnNumber: 7
    }
  }, versus), /*#__PURE__*/_react.default.createElement(TeamOpposing, {
    width: [1],
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 226,
      columnNumber: 7
    }
  }, (cov_ixxzv2rg4().b[2][0]++, opposingTeam.logo) && (cov_ixxzv2rg4().b[2][1]++, /*#__PURE__*/_react.default.createElement(TeamLogo, {
    src: opposingTeam.logo.small,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 227,
      columnNumber: 31
    }
  })), /*#__PURE__*/_react.default.createElement(TeamName, {
    name: opposingTeam.name,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 228,
      columnNumber: 9
    }
  })));
}
cov_ixxzv2rg4().s[13]++;
MatchTeamDetail.propTypes = {
  /* The hostTeam object to display */
  hostTeam: _product.ProductType.isRequired,
  /* The n object to display */
  opposingTeam: _product.ProductType.isRequired,
  /** Type definitions for react-intl, using for dynamic message */
  intl: _reactIntl.intlShape.isRequired,
  themeContext: _themeProvider.ThemeContextType,
  themeQueries: _utils.WithThemeQueriesType
};
cov_ixxzv2rg4().s[14]++;
MatchTeamDetail.defaultProps = {
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {}
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)((0, _utils.withMediaQueries)((0, _reactIntl.injectIntl)(MatchTeamDetail))));